import * as React from "react";
import {MobileLoopCarousel} from "../mobile-loop-carousel/MobileLoopCarousel";
import {CarouselSlide} from "../carousel-slide/CarouselSlide";
import {CarouselProps} from "../Carousel";
import * as styles from "./carousel-layout.module.scss";

interface Props extends CarouselProps {
  selectedSlideIndex: number;
  onSelectedSlideChange: (newIndex: number, prevIndex: number) => void;
}

export function CarouselLayout(props: Props) {
  const {
    mediaSpaceAllocation,
    textTransition,
    imageLocation,
    mobileLayoutOnly,
    slides,
    selectedSlideIndex,
    onSelectedSlideChange,
    darkMode,
  } = props;

  if (!slides) {
    return null;
  }
  return (
    <React.Fragment>
      {/* Used for Desktop Size Screens */}
      {!mobileLayoutOnly && (
        <div className={styles.carouselLayout__slides}>
          <div
            role="region"
            aria-live="polite"
            className={styles.carouselLayout__slides__container}
            style={{transform: `translateX(${selectedSlideIndex * -100}%)`}}
          >
            {slides.map(
              (slide, index) =>
                slide && (
                  <CarouselSlide
                    key={index}
                    slide={slide}
                    slideIndex={index}
                    selectedSlideIndex={selectedSlideIndex}
                    textTransition={textTransition}
                    imageLocation={imageLocation}
                    mediaSpaceAllocation={mediaSpaceAllocation}
                    darkMode={darkMode}
                    mobileLayoutOnly={mobileLayoutOnly}
                  />
                )
            )}
          </div>
        </div>
      )}

      {/* Used for Mobile Size Screens */}
      <div
        className={!mobileLayoutOnly ? styles.carouselLayout__mobileSlides : ""}
      >
        <MobileLoopCarousel
          slides={slides}
          onCurrentSlideChange={onSelectedSlideChange}
          selectedSlideIndex={selectedSlideIndex}
        >
          {(slide, index) =>
            slide && (
              <CarouselSlide
                key={index}
                slide={slide}
                slideIndex={index}
                selectedSlideIndex={selectedSlideIndex}
                textTransition={textTransition}
                imageLocation={imageLocation}
                mediaSpaceAllocation={mediaSpaceAllocation}
                darkMode={darkMode}
                mobileLayoutOnly={mobileLayoutOnly}
              />
            )
          }
        </MobileLoopCarousel>
      </div>
    </React.Fragment>
  );
}
